import API from '../utils/api';

export const getAppVersions = async (queryParams = { limit: 10, skip: 0 }) => {
   let query = `limit=${queryParams.limit}&skip=${queryParams.skip}`

   return API.get(`/admin/version/get?${query}`);
}

export const updateAppVersion = async (versionId, versionData = {}) => {
   return API.post(`/admin/version/update/${versionId}`, versionData);
}

export const addAppVersion = async (versionData) => {
   return API.post(`/admin/version/create`, versionData);
}

export const deleteAppVersion = async (versionId = "") => {
   return API.delete(`/admin/version/delete/${versionId}`);
}
